import { ThemeContextProvider } from '@/contexts/ThemeContext'
import { NextPageWithLayout } from '@/layouts'
import { ContentOnlyLayout } from '@/layouts/ContentOnlyLayout'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { getUserGuildStatus } from '@/utils/users/usersServer'
import { WelcomeView } from '@/views/WelcomeView'

export const WelcomeHome: NextPageWithLayout = () => {
  return (
    <ThemeContextProvider isDarkMode>
      <WelcomeView />
    </ThemeContextProvider>
  )
}

export const getServerSideProps = getServerSidePropsErrorHandler(async ({ locale, userId }) => {
  const guildStatus = !userId ? null : await getUserGuildStatus(userId)

  if (guildStatus && guildStatus.isGuildMember) {
    return {
      redirect: {
        destination: '/guild',
        permanent: false,
      },
    }
  }

  return {
    props: {
      locale,
      ...(await loadTranslations(locale, ['common', 'sign-up'])),
    },
  }
})

WelcomeHome.getLayout = (page) => {
  return <ContentOnlyLayout>{page}</ContentOnlyLayout>
}

export default WelcomeHome
